import { useExternalScript } from '@whistler-ui/k2/hooks/UseExternalScriptOptions';
import { useEffect } from 'react';

import { useAuthStore } from '../../store/auth';

const PRODUCT_ID = 'JKpoRsZd82508';

declare global {
  interface Window {
    beamer_config?: { product_id: string; user_id: string };
  }
}

/**
 * Loads the Beamer changelog widget once the organisation is known. Renders
 * nothing; mounted inside the cookie-consent wrapper.
 */
export const BeamerConfig = () => {
  const {
    authValues: {
      organisationState: { organisation: org },
    },
  } = useAuthStore();

  const orgId = org?.id;

  // Beamer reads its config from this global when the embed script runs, so
  // this effect is declared first to run before the script is injected.
  useEffect(() => {
    if (!orgId) {
      return;
    }

    window.beamer_config = { product_id: PRODUCT_ID, user_id: `${orgId}` };
  }, [orgId]);

  useExternalScript({
    src: 'https://app.getbeamer.com/js/beamer-embed.js',
    id: PRODUCT_ID,
    enabled: Boolean(orgId),
  });

  return null;
};
